const $bestSellerProducts = $('.best-seller__product-list');
const $bestSellerAriaLive = $("#best-seller-aria-live");

if ($bestSellerProducts.length > 0) {
  $bestSellerProducts.slick({
    slidesToShow: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $('[data-best-seller-product-list-left-arrow]').click(function() {
    $bestSellerProducts.slick('slickPrev');
  });

  $('[data-best-seller-product-list-right-arrow]').click(function() {
    $bestSellerProducts.slick('slickNext');
  });

 $('[data-best-seller-product-list-left-arrow]').keypress(function (event) { 
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    $bestSellerProducts.slick('slickPrev');
  }
 });

 $('[data-best-seller-product-list-right-arrow]').keypress(function (event) { 
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    $bestSellerProducts.slick('slickNext');
  }
 });

  /**
   * Updates the Aria live text based on the current and last active slide indices.
   * @param {Object} slick - The Slick carousel object.
   * @param {number} currentSlide - The index of the current slide (is undefined on init).
   */
  $bestSellerProducts.on('init reInit afterChange', function(event, slick, currentSlide){
    let currentSlideIndex = (currentSlide ? currentSlide : 0) + 1;
    let secondSlideIndex = (currentSlide ? currentSlide + 2 : 2);
    let lastSlideIndex = (currentSlide ? currentSlide + 3 : 3);

    if (lastSlideIndex > slick.slideCount) {
      lastSlideIndex = lastSlideIndex - slick.slideCount;
    }

    if (secondSlideIndex > slick.slideCount) {
      secondSlideIndex = secondSlideIndex - slick.slideCount;
    }

    let displayText = `Displaying slide ${currentSlideIndex}, ${secondSlideIndex}, and ${lastSlideIndex} of ${slick.slideCount}`;

    $bestSellerAriaLive.text(displayText);
  });
}
